import Waiting from '@/store/waiting';
import { isLeadSynced } from '@/utils/salesforce';

export default class FreeActionActions {
  constructor (Api, types) {
    const actions = {
      async createFreeActionAction ({ commit, dispatch, getters }, args) {
        await waiting.check('createFreeActionAction', async () => {
          const res =  await Api.createFreeAction(args);

          if (isLeadSynced(getters.callTarget)) {
            await dispatch('createFreeActionSfTaskAction', {
              body: {
                callTargetId: args.callTargetId,
                targetId: res.data.id,
              },
            });
          }

          return;
        });
      },
      // balesのコメント（free_action）を更新した後、SF連携済みリードの場合はSalesforceのTaskも更新する
      async updateFreeActionAction ({ commit, dispatch, getters }, args) {
        await waiting.check('updateFreeActionAction', async () => {
          await Api.updateFreeAction(args);

          // SF連携済みリードの場合、SalesforceのTaskも更新する
          // callTargetId は args.callTargetId または body.freeAction.callTargetId から取得する
          const callTargetId = args.callTargetId ?? args.body?.freeAction?.callTargetId ?? args.body?.freeAction?.call_target_id;
          if (isLeadSynced(getters.callTarget)) {
            await dispatch('updateFreeActionSfTaskAction', {
              body: {
                callTargetId,
                targetId: args.freeActionId,
              },
            });
          }
        });
      },
      async deleteFreeActionAction ({ commit }, args) {
        await waiting.check('deleteFreeActionAction', async () => {
          await Api.deleteFreeAction(args);
          try {
            const res = await Api.getLeadHistories(args);
            commit(types.SET_LEAD_HISTORIES, Object.values(res.data)[0]);
          } catch (err) {
            throw err;
          }
        });
      },
    };
    const waiting = new Waiting(actions);
    this.actions = actions;
  }
}
